<script>
import { Line } from 'vue-chartjs'
export default {
    name: 'revenuesCountItens',
    extends: Line,
    props: [
        'options',
        'chartData'
    ],
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
}
</script>
<style scoped>

</style>